import type {RouteRecordRaw} from "vue-router";

import {EPermissao} from "@/core/type/permissao.type";

export const atividadesRoutes: RouteRecordRaw[] = [
    {
        path: "/atividades",
        name: "atividades",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_LISTAR_ATIVIDADES},
        component: () => import("@/modules/atividades/pages/PageAtividades.vue")
    },
];
